import { Category } from "../../types";
import { DtoEntry } from "../../../../../types/dto-types";
import { DynamicTestSetWithCategory } from "../../utils";

export function calculateCategoryCounts(
  entries: DtoEntry[],
  dynamicTestSets: DynamicTestSetWithCategory[]
): Record<Category, number> {
  const categoryMap = new Map<string, Category>();
  dynamicTestSets.forEach(dynamicTestSet => {
    if (dynamicTestSet.category) {
      categoryMap.set(dynamicTestSet._id, dynamicTestSet.category as Category);
    }
  });

  return entries.reduce(
    (acc, entry) => {
      const category = categoryMap.get(entry.testSetId);
      if (category) {
        acc[category] = (acc[category] || 0) + 1;
      }
      return acc;
    },
    {
      [Category.Organization]: 0,
      [Category.Team]: 0,
      [Category.Leadership]: 0,
    } as Record<Category, number>
  );
}

export function getTotalFromCategoryCounts(
  categoryCounts: Record<Category, number>
): number {
  return Object.values(categoryCounts).reduce((sum, count) => sum + count, 0);
}
